import React from "react";
import { getIn, useFormikContext } from "formik";
import { withNamespace } from "components/Form/FormikControls";
import Grid from "@material-ui/core/Grid";
import { SlimButton, SlimSecondaryButton } from "components/Button";
import { Row } from "components/Layout";
import { EmailRecipientsTable } from "./EmailRecipientsTable";
import { EmailRecipientFormSection } from "./EmailRecipientForm";

interface EmailRecipientsPanelProps {
  masterBusinessId: string;
  primaryContactEmail: string | null;
  namespace: string;
  onEndEditing: () => void;
  onStartEditing: () => void;
  onSetPrimaryContactEmail: (email: string) => void;
}

export function EmailRecipientsPanel(
  props: EmailRecipientsPanelProps,
): React.JSX.Element {
  const {
    masterBusinessId: businessId, // TODO - rename to businessId, and deprecate the master prefix.
    primaryContactEmail,
    namespace: ns,
    onEndEditing,
    onStartEditing,
    onSetPrimaryContactEmail,
  } = props;
  const formikContext = useFormikContext();
  const { values, dirty, isValid } = formikContext;

  // Get the current Specific Business's EmailRecipients from the Formik state
  const editingEmailRecipient = getIn(
    values,
    withNamespace(ns, "editingValue"),
  ) as EmailRecipient | null | undefined;

  const isRevertEnabled = dirty;

  const isSubmitEnabled = dirty && isValid && editingEmailRecipient === null;

  return (
    <>
      <EmailRecipientFormSection
        namespace={ns}
        onSetPrimaryContactEmail={onSetPrimaryContactEmail}
      />

      <EmailRecipientsTable
        businessId={businessId}
        primaryContactEmail={primaryContactEmail}
        namespace={ns}
        onEndEditing={onEndEditing}
        onStartEditing={onStartEditing}
        onSetPrimaryContactEmail={onSetPrimaryContactEmail}
      />

      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} sm={9} />
        <Grid item xs={12} sm={3} container justifyContent="flex-end">
          <Row justifyBetween>
            <SlimSecondaryButton type="reset" disabled={!isRevertEnabled}>
              Revert Changes
            </SlimSecondaryButton>
            &nbsp;
            <SlimButton
              type="submit"
              disabled={!isSubmitEnabled}
              data-tour="emailSubmit"
            >
              Accept Changes
            </SlimButton>
          </Row>
        </Grid>
      </Grid>
    </>
  );
}
